module.exports = __webpack_public_path__ + "static/media/6cb64d93-5035-446e-bfd0-2f021e69f01f_1.a8c8cde7c9ffa671141f6ba866497a5e.e7668414.jpeg";